import { AuthResponse, MccsRoles } from '@/@types/generated'
import { Feature } from './feature'
import { hasRole } from '@/components/Atoms/Permissions'

export const HelpDocumentsFeature = {
  // Roles that are eligible for the HelpDocuments feature
  Roles: [
    MccsRoles.ADMINISTRATOR,
    MccsRoles.CREDENTIALING,
    MccsRoles.CREDENTIALING_ADMIN,
    MccsRoles.CHIEF_INVESTIGATOR,
    MccsRoles.INVESTIGATOR,
    MccsRoles.LEGAL,
    MccsRoles.FINANCE,
  ],

  // Determine if the feature is enabled for the given user
  isEnabled: (user: AuthResponse | null): boolean =>
    hasRole(HelpDocumentsFeature.Roles, user),
} satisfies Feature
